import { render, staticRenderFns } from "./CampaignExpire.vue?vue&type=template&id=1982aac0&scoped=true"
import script from "./CampaignExpire.vue?vue&type=script&lang=js"
export * from "./CampaignExpire.vue?vue&type=script&lang=js"
import style0 from "./CampaignExpire.vue?vue&type=style&index=0&id=1982aac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1982aac0",
  null
  
)

export default component.exports